import React, { useContext } from 'react';
import { isVeloSpisSite } from '../../../../utils';
import { StoreContext } from '../../../appContext/StoreProvider';
import { ApiDisplay, API_TYPES } from '../../ApiDisplay';
import { FeedbackContainer } from '../../Feedback';
import MemberDocs, { MemberTypes } from '../MemberDocs';
import { RelatedContentEndOfArticle } from '../RelatedContentEndOfArticle';
import typeDetailsStyle from '../typeDetails.scss';
import { JSOperationView } from './JSOperationView';
import { RESTOperationView } from './RESTOperationView';
import { RPCOperationView } from './RPCOperationView';
import { AuthorizationAndPermissions } from './AuthorizationAndPermissions';
import { StatusCodeNote } from './StatusCodeNote';
import get from 'lodash/get';

export default function OperationDetails({ operation, node, id, prefix }) {
  const { store } = useContext(StoreContext);
  const artifactId =
    operation?.extra?.artifactId || node?.data?.extra?.artifactId;
  const hasLinks = operation?.docs?.links?.length > 0;
  const hasRest = get(operation, 'extra.hasRest', true);
  const isSpiDocs = isVeloSpisSite(store?.viewer?.category);
  const JSLayoutType = node?.data?.layoutType === 'JS';

  return (
    <div className={typeDetailsStyle.typeDetails}>
      <MemberDocs
        memberType={MemberTypes.OPERATION}
        memberObject={operation}
        node={node}
        prefix={prefix}
      />
      {JSLayoutType ? (
        <JSOperationView
          operation={operation}
          prefix={prefix}
          artifactId={artifactId}
          JSLayoutType={JSLayoutType}
        />
      ) : (
        <>
          <ApiDisplay.REST showOnTypes={[API_TYPES.RPC_REST, API_TYPES.RPC]}>
            <AuthorizationAndPermissions
              isSpiDocs={isSpiDocs}
              permissions={operation.permissions}
            />
          </ApiDisplay.REST>

          <ApiDisplay.RPC forceRender={!hasRest}>
            <RPCOperationView
              operation={operation}
              artifactId={artifactId}
              serviceName={operation.serviceName}
              prefix={prefix}
            />
          </ApiDisplay.RPC>

          <ApiDisplay.JS>
            <JSOperationView
              operation={operation}
              prefix={prefix}
              artifactId={artifactId}
            />
          </ApiDisplay.JS>

          <ApiDisplay.REST
            showOnTypes={[API_TYPES.RPC_REST]}
            forceHide={!hasRest}
          >
            <RESTOperationView
              operation={operation}
              prefix={prefix}
              artifactId={artifactId}
            />
          </ApiDisplay.REST>

          <ApiDisplay.REST showOnTypes={[API_TYPES.RPC, API_TYPES.RPC_REST]}>
            {!isSpiDocs && <StatusCodeNote />}
          </ApiDisplay.REST>
        </>
      )}
      {hasLinks && (
        <RelatedContentEndOfArticle
          links={operation.docs.links}
          prefix={prefix}
        />
      )}
      <FeedbackContainer memberId={id} />
    </div>
  );
}
